import { MotifAccordion, MotifAccordionContent, MotifAccordionTrigger, MotifButton, MotifIcon } from '@ey-xd/motif-react'

const AppAccordion = (props: any) => {
    const { children, title } = props;
    return (
        <>
            <MotifAccordion
                onClose={function Ga() { }}
                onOpen={function Ga() { }}
            >
                <MotifAccordionTrigger>
                    {title}
                </MotifAccordionTrigger>
                <MotifAccordionContent>
                    {children}
                </MotifAccordionContent>
            </MotifAccordion>
        </>
    )
}

export default AppAccordion